module.exports = __webpack_public_path__ + "img/111skin2.616c03fe.jpg";